export class MenuButtonEvents {
	public static readonly MENU_BUTTON_CLICKED: string = 'MenuButtonEvents::MENU_BUTTON_CLICKED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/menuButton/MenuButtonEvents.ts